import _ from "lodash";

export const toCurrencyFormat = (amount, currency) => {
  if (!currency) {
    currency = "KZT";
  }

  if (!amount) {
    amount = 0;
  }

  if (typeof amount === "string") {
    amount = Number(amount);
  }

  const format = new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: currency,
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return format.format(amount);
};

export const CURRENCY = {
  USD: "USD",
  KZT: "KZT",
  RUB: "RUB",
};

export const getFullName = (customer) => {
  if (!customer) {
    return "-";
  }
  if (!customer.lastName && !customer.firstName) {
    if (customer.user?.phone) {
      return customer.user?.phone;
    }
    return "-";
  }
  return (customer?.lastName || "") + " " + (customer?.firstName || "");
};
